export const createSsapInputId = (indexInArray, fields, name, areAllFieldsMixed = undefined, valueToPass = null) => {
    const getFields = arr => {
        if(Array.isArray(arr)) {
            return arr.length === 0
                ? ''
                : areAllFieldsMixed
                    ? `${arr.join('_')}`
                    : `${arr[arr.length - 1]}`;
        } else {
            return '';
        }
    };

    const getHouseholdMemberIndex = index => {
        switch(true) {
            case typeof index === 'number':
                return index;
            case Array.isArray(index):
                return index.reduce((outputStr, el) => {
                    const suffix = getHouseholdMemberIndex(el);
                    if(suffix !== null) {
                        return `${outputStr}_${getHouseholdMemberIndex(el)}`;
                    } else {
                        return outputStr;
                    }
                }, '');
            default:
                return null;
        }
    };

    const append = value => {
        switch(true) {
            case typeof value === 'string':
                return `_${value.toLowerCase()}`;
            case typeof value === 'number':
                return `_${value}`;
            default:
                return '';
        }
    };

    const prepend = value => value !== null ? `hhm${value}_` : '';
    const hhmPrefix = prepend(getHouseholdMemberIndex(indexInArray));
    const fieldsStr = getFields(fields);

    // Only add underscore before name if there's a prefix (hhm or fields)
    //if fieldsStr !== '' then hasPrefix is true. 
    const hasPrefix = fieldsStr !== '';
    const nameWithConditionalUnderscore = hasPrefix ? `_${name}` : name;

    return [
        hhmPrefix,
        fieldsStr,
        nameWithConditionalUnderscore,
        append(valueToPass)
    ].join('');
};